<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span class="headline">{{ group.activityRepr }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh/>
    </v-card-title>
    <v-card-text class="pt-4">
      <DataTable
        :items.sync="tableItems"
        :headers="tableHeaders"
        :customCells="customCells"
        tableKey="rowKey"
        :showSearch="false"
      >
        <template #field="{ item }">
          <span v-for="(seg, i) in item.fieldSegments" :key="i">
            <span v-if="i > 0" class="grey--text px-1" style="user-select: none">{{ '>' }}</span>
            {{seg}}
          </span>
        </template>
      </DataTable>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RateSheetLineAuditDialog',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue')
  },

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  computed: {
    tableHeaders () {
      return [
        { text: this.$t('field'), value: 'fieldSegments', sortable: false },
        { text: this.$t('type'), value: 'opType', sortable: true },
        { text: this.$t('from'), value: 'from', sortable: false },
        { text: this.$t('to'), value: 'to', sortable: false }
      ]
    },
    customCells () {
      return [{ slotName: 'field', value: 'fieldSegments' }]
    },
    tableItems () {
      return this.group.subEntries.map(sub => ({
        ...sub,
        fieldSegments: sub.componentSegments.slice(4)
      }))
    }
  }
}
</script>
